export enum ActivityTypeEnum {
  Create = 'CREATE',
  Update = 'UPDATE',
  Delete = 'DELETE'
}
